<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-expand-lg bg-white">
					<!-- Page title -->
					<div class="navbar-text nav-title flex" id="pageTitle">Student Setup</div>

					<!-- Search field -->
					<div>
						<form class="input-group m-2 my-lg-0">
							<span class="input-group-btn">
								<button type="button" class="btn no-border no-bg no-shadow">
									<i class="fa fa-search"></i>
								</button>
							</span>
							<input type="text" v-model="filter" class="form-control" placeholder="Search students..." />
						</form>
					</div>
				</div>

				<div class="content-main">
					<div class>
						<!-- Page content goes here -->
						<b-table
							ref="table"
							responsive="lg"
							striped
							hover
							:show-empty="true"
							:items="table_provider"
							:fields="table_fields"
							:current-page="currentPage"
							:per-page="perPage"
							:filter="filter"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
						>
							<!-- Edit -->
							<!-- <template slot="actions" slot-scope="data">
								<nobr>
									<div class="mx-auto w60">
										<a :href="`#/admin/class/${data.item.id}`" class="btn btn-sm btn-icon btn-rounded hover-darken theme-accent m-0"
										    v-tippy title="Edit">
											<i class="far fa-edit"></i>
										</a>
										<button v-if="!data.item.inProgress" @click="deleting = data.item" class="btn btn-sm btn-icon btn-rounded hover-darken red text-white m-0"
										    v-tippy title="Delete">
											<i class="far fa-trash"></i>
										</button>
										<button v-if="data.item.inProgress" class="btn btn-sm btn-icon btn-rounded m-0" v-tippy title="Removing...">
											<loading type="icon" />
										</button>
									</div>
								</nobr>
							</template>-->

							<template slot="ref_id" slot-scope="data">
								<span v-if="data.item.ref_id">{{ data.item.ref_id }}</span>
								<span v-if="!data.item.ref_id" class="text-extra-muted">None</span>
							</template>

							<template slot="email" slot-scope="data">
								<span v-if="data.item.email">{{ data.item.email }}</span>
								<span v-if="!data.item.email" class="text-extra-muted">None</span>
							</template>

							<template slot="district" slot-scope="data">
								<span v-if="data.item.district && data.item.district.name">{{
									data.item.district.name
								}}</span>
								<span v-if="!(data.item.district && data.item.district.name)" class="text-danger">
									<i class="fas fa-exclamation-circle" />
									None
								</span>
							</template>

							<template slot="classes" slot-scope="data">
								<span
									v-if="data.item.classes && data.item.classes.length > 0"
									v-tippy="{ theme: 'popover' }"
									:title="listNames(data.item.classes, 'Classes')"
								>
									<i class="fas fa-chalkboard fa-fw"></i>
									{{ (data.item.classes && data.item.classes.length) || 0 }}
								</span>
								<span
									v-if="!(data.item.classes && data.item.classes.length > 0)"
									class="text-extra-muted"
									>None</span
								>
							</template>

							<template slot="empty">
								<loading type="table" v-if="loading" />
								<div v-if="!loading">There are no records to show</div>
							</template>
						</b-table>
					</div>
				</div>

				<div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
					<a class="flex mx-3"
						>Page {{ totalRows > 0 ? currentPage : 0 }} of {{ Math.ceil(totalRows / perPage) }} ({{
							totalRows
						}})</a
					>
					<div>
						<b-pagination
							size="md"
							class="m-1"
							:total-rows="totalRows"
							v-model="currentPage"
							:per-page="perPage"
						></b-pagination>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w60 {
	width: 60px;
}
</style>

<script>
import StudentService from "@/services/StudentService";
import notie from "@/services/NotieService";
import store from "@/services/Store";

export default {
	name: "StudentList",

	props: ["user"],

	data() {
		return {
			table_fields: [
				{
					key: "full_name",
					label: "Name",
					tdClass: "_600",
					sortable: true
				},
				{ key: "ref_id", label: "Ref ID", sortable: true },
				{ key: "email", label: "Email", sortable: true },
				{ key: "district", label: "District" },
				{ key: "classes", label: "Classes" }
			],
			currentPage: 1,
			perPage: 15,
			totalRows: 0,
			filter: "",
			sortBy: null,
			sortDesc: false,
			loading: true,

			deleting: false
		};
	},

	components: {},

	created() {
		this.sortBy = store.get(this, "students.sortBy");
		this.sortDesc = store.getDefault(this, "students.sortDesc", false);
	},

	watch: {
		sortBy() {
			store.set(this, "students.sortBy", this.sortBy);
		},
		sortDesc() {
			store.set(this, "students.sortDesc", this.sortDesc);
		}
	},

	methods: {
		table_provider(ctx) {
			return StudentService.listStudentsWithClasses(ctx)
				.then(resp => {
					this.totalRows = resp.data.totalRows;
					return resp.data.students;
				})
				.catch(err => {
					console.log(err);
					notie.error("Failed to load students", err);
					return [];
				})
				.finally(() => {
					this.loading = false;
				});
		},

		refreshTable() {
			this.$refs.table.refresh();
		},

		listNames(objects, title) {
			if (objects && objects.length > 0) {
				let nameList = `${title}:<br /><br /><ul class='pl-4 pr-3'>`;
				_.each(objects, object => {
					nameList += `<li style="text-align: left;">${object.name}</li>`;
				});

				return nameList + "</ul>";
			} else {
				return "";
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/StudentList.vue